"use client";

import { useEffect } from "react";

export function ThemeInit() {
  useEffect(() => {
    try {
      const theme = localStorage.getItem("corely-theme") || "blue";
      const scheme = localStorage.getItem("corely-color-scheme") || "light";
      document.documentElement.setAttribute("data-theme", theme);
      document.documentElement.setAttribute("data-color-scheme", scheme);
      if (scheme === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    } catch {}
  }, []);

  return null;
}
